import React, { forwardRef } from 'react';

import AddBox from '@material-ui/icons/AddBox';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { Icons as TypeIcons } from 'material-table';

export const  Icons: TypeIcons = {
  Add: forwardRef((props: any, ref: any) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props: any, ref: any) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props: any, ref: any) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props: any, ref: any) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props: any, ref: any) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props: any, ref: any) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props: any, ref: any) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props: any, ref: any) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props: any, ref: any) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props: any, ref: any) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props: any, ref: any) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props: any, ref: any) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props: any, ref: any) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props: any, ref: any) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props: any, ref: any) => <KeyboardArrowDown {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props: any, ref: any) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props: any, ref: any) => <ViewColumn {...props} ref={ref} />),
};

export const Options = {
  pageSize: 10,
  actionsColumnIndex: -1,
  headerStyle: {
    color: '#444',
    fontWeight: 'bold',
    lineHeight: '1rem'
  } as React.CSSProperties,
};

export const Localization = {
  toolbar: {
    searchPlaceholder: "Pesquisar",
    nRowsSelected: "{0} Linha(s) selecionada(s)",
    exportName: "Exportar para Excel"
  },
  header: {
    actions: ''
  },
  pagination: {
    labelRowsSelect: "linhas",
    labelDisplayedRows: '{from}-{to} de {count}',
    nextTooltip: "Próxima página",
    previousTooltip: "Página anterior",  
    lastTooltip: "Última página",
    firstTooltip: "Primeira página",
    totalCount:1000
  },
  body: {
    emptyDataSourceMessage: 'Nenhum registro encontrado'
  }
}